import React from "react";

const ProgressRenderer = (props: any) => {
  const value = Number(props.value ?? 0);
  const format = props.format;

  const formatNumber = (value: number, format?: string) => {
    if (!format) return value;

    const decimal = format.includes(".") ? format.split(".")[1].length : 0;

    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  };

  const displayValue = formatNumber(value, format);

  if (props.node?.footer || props.node?.rowPinned) {
    return null;
  }

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          width: "100%",
          height: "70%",
          background: "#e5e7eb",
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${Math.min(Math.max(value, 0), 100)}%`,
            height: "100%",
            background: "linear-gradient(90deg, #1e40af, #60a5fa)",
            borderRadius: 4,
            transition: "width 0.3s ease",
          }}
        />
      </div>

      <div
        style={{
          position: "relative",
          width: "100%",
          textAlign: "center",
          zIndex: 1,
          color: value > 50 ? "#ffffff" : "#334155",
          fontWeight: 600,
          textShadow: "0 1px 2px rgba(0,0,0,0.25)",
        }}
      >
        {displayValue}%
      </div>
    </div>
  );
};

export default ProgressRenderer;
